const testimonials = [
  {
    name: '陈总',
    role: '某中型制造企业 CEO',
    content: '我们通过无码平台在3个月内完成了数字化转型，搭建了生产管理、库存管理和质量管理系统。生产效率提升了40%，这个效果远超我们的预期。',
    logo: '制造业',
  },
  {
    name: '刘经理',
    role: '某连锁零售品牌 IT总监',
    content: '无码让我们的小型IT团队也能快速响应业务需求。以前开发一个管理系统需要3个月，现在2周就能上线，而且质量完全不输传统开发。',
    logo: '零售业',
  },
  {
    name: '周女士',
    role: '某科技创业公司 产品负责人',
    content: '作为非技术背景的创业者，无码让我第一次感受到了自己动手搭建产品的乐趣。从想法到产品上线，整个过程非常流畅。',
    logo: '科技行业',
  },
  {
    name: '孙总',
    role: '某B2B贸易公司 总经理',
    content: '我们用无码搭建了B2B电商平台，支持千级SKU和在线交易。整个项目从启动到上线只用了60天，成本比外包开发降低了80%。',
    logo: '贸易行业',
  },
  {
    name: '吴女士',
    role: '某教育机构 运营总监',
    content: '无码的自动化流程功能让我们的学员管理效率提升了200%。从报名到课程安排，所有的流程都实现了自动化，团队可以把时间花在更有价值的事情上。',
    logo: '教育行业',
  },
  {
    name: '郑先生',
    role: '某金融机构 技术经理',
    content: '在金融行业，合规和安全是第一位的。无码平台的企业级安全防护和灵活的权限管理让我们很放心，审批流程的自动化也大大缩短了业务处理时间。',
    logo: '金融行业',
  },
];

export default function CasesSection() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-sm font-medium mb-4">
            客户案例
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            数千家企业选择无码，听听他们怎么说
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto leading-relaxed">
            从初创公司到行业龙头，无码正在帮助各行各业的客户实现数字化升级。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="p-7 rounded-2xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-4 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-6">&ldquo;{t.content}&rdquo;</p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 text-sm font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-10 opacity-50">
          {['制造业', '零售业', '教育', '金融', '科技', '贸易', '医疗', '物流'].map((industry) => (
            <span key={industry} className="text-sm text-foreground-500 font-medium whitespace-nowrap">
              {industry}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}